<template>
  <div class="component routing-page">
    <div class="top_line text-left">
      <h2 class="title pb-5 text-2xl fw-b">Routing</h2>
    </div>
    <div class="routing-settings title_line flex items-center gap-20">
      <div class="flex items-center gap-20">
        <div>Engine</div>
        <select
            v-model="api_version"
            @change="updateUser"
            id="api_version">
          <option disabled :value="api_version">{{ api_version }}</option>
          <option :value="'v1'">v1</option>
          <option :value="'v2'">v2</option>
        </select>
      </div>
      <div v-if="api_version === 'v2'" class="flex items-center gap-2">
        <input type="checkbox" v-model="driver_use_segments" @change="saveDriverSettings"/>
        <span>Use for drivers</span>
      </div>
    </div>

    <div v-if="api_version === 'v2'" class="exclusions-wrap">
      <router-view />
    </div>

    <TextRedactor v-if="showRouteInfoEditor"/>
  </div>
</template>

<style scoped lang="scss">
.routing-settings {
  width: 100%;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.exclusions-wrap {
  width: 100%;
  min-width: 0;
  margin-top: 24px;
  text-align: left;
}
</style>

<script>
import {baseErrHandler, updateUser} from "@/services/api";
import TextRedactor from "@/components/TextRedactor.vue";

export default {
  name: "Routing",
  components: {TextRedactor},
  data() {
    return {
      api_version: null,
      driver_use_segments: false,
    }
  },
  methods: {
    async updateUser() {
      await baseErrHandler(async () => {
        const this_user = await updateUser({api_version: this.api_version});
        await localStorage.setItem('user', JSON.stringify(this_user));
      });
    },
    async saveDriverSettings() {
      await baseErrHandler(async () => {
        const this_user = await updateUser({driver_use_segments: this.driver_use_segments});
        await localStorage.setItem('user', JSON.stringify(this_user));
      });
    },
  },
  mounted() {
    const user = JSON.parse(localStorage.getItem('user'));
    this.api_version = user.api_version || 'v1';
    this.driver_use_segments = user.driver_use_segments || false;
  },
  computed: {
    showRouteInfoEditor() {
      return this.api_version === 'v1';
    },
  },
}
</script>
